import { createFileRoute } from "@tanstack/react-router";
import { lazyNamed } from "@/lib/lazy-route";

import { cavityInsulationRemovalLp as content } from "@/content/landing/cavity-insulation-removal";
import { breadcrumbJsonLdScript, servicesBreadcrumbTrail } from "@/lib/breadcrumbs";
import { pageSeo, serviceJsonLdScript } from "@/lib/seo";
import { SITE } from "@/lib/site";
import { SymptomProvider } from "@/context/symptom-context";
import heroHouse1920 from "@/assets/lp/hero-house-1920w.webp";
import heroHouse1024 from "@/assets/lp/hero-house-1024w.webp";
import heroHouse640 from "@/assets/lp/hero-house-640w.webp";

const LpCavityInsulationRemovalPage = lazyNamed(
  () => import("@/components/landing/lp-cavity-insulation-removal"),
  "LpCavityInsulationRemoval",
);

export const Route = createFileRoute("/lp/cavity-insulation-removal")({
  head: () => ({
    ...pageSeo({
      path: content.path,
      title: content.metaTitle,
      description: content.metaDescription,
      image: content.heroImage,
      ogType: "article",
    }),
    links: [
      {
        rel: "preload",
        as: "image",
        href: heroHouse1920,
        imageSrcSet: `${heroHouse640} 640w, ${heroHouse1024} 1024w, ${heroHouse1920} 1920w`,
        imageSizes: "100vw",

        fetchPriority: "high",
      },
    ],
    scripts: [
      serviceJsonLdScript({
        name: content.title,
        description: content.metaDescription,
        serviceType: "Cavity Wall Insulation Removal",
        url: `${SITE.url}${content.path}`,
        image: content.heroImage,
      }),
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: content.faqs.map((f) => ({
            "@type": "Question",
            name: f.question,
            acceptedAnswer: { "@type": "Answer", text: f.answer },
          })),
        }),
      },
      breadcrumbJsonLdScript(servicesBreadcrumbTrail(content.title, content.path)),
    ],
  }),
  component: () => (
    <SymptomProvider>
      <LpCavityInsulationRemovalPage />
    </SymptomProvider>
  ),
});
